import React from 'react'

function Strock() {
  return (
    <svg width={2} height={16} viewBox="0 0 2 82" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.661133 0.25V81.75" stroke="black" />
    </svg>
  )
}

export default Strock